import { SectionHeading, ServiceCard } from '@/shared/components/SolarSections';
import { featuredServices } from '@/shared/utils/SolarData';

const ServicesPage = () => {
  return (
    <div className="px-4 pt-8 pb-16 sm:px-6 lg:px-8 lg:pt-12 lg:pb-24">
      <div className="mx-auto max-w-7xl space-y-12">
        <SectionHeading
          eyebrow="Services"
          title="Solar services designed for every type of property"
          description="From first consultation to post-installation maintenance, our services are built to deliver reliable results."
          align="center"
        />

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {featuredServices.map((service, index) => (
            <ServiceCard key={service.title} {...service} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;